import * as React from 'react';

import * as Entri from 'entrijs';

import {SingleInputModal} from 'shells/single-input-modal/single-input-modal';

import {useAddSubdomain} from './graphql/hooks';
import {useCreateEntriConfig} from './graphql/hooks/use-create-entri-config';

type Props = {
    domain: string;
    setIsAddingSubdomain: (arg1: boolean) => void;
    toggleRowExpanded: (arg1: boolean) => void;
};

export function AddSubdomainModal(props: Props) {
    const {addSubdomain, isAdding, error: errorMessage} = useAddSubdomain();
    const {createEntriConfig} = useCreateEntriConfig();

    const onSave = (subdomain: string) => {
        addSubdomain({domain: props.domain, subdomain}).then(() => {
            createEntriConfig({domain: props.domain, subdomain: subdomain}).then((config) => {
                Entri.showEntri(config);
            });
            props.setIsAddingSubdomain(false);
            props.toggleRowExpanded(true);
        });
    };

    return (
        <SingleInputModal
            isSaving={isAdding}
            onClose={() => props.setIsAddingSubdomain(false)}
            onSave={onSave}
            buttonText='Start authentication'
            title='Add new subdomain'
            subtitle={`Domain ${props.domain} will be appended to the subdomain`}
            placeholder='subdomain'
            errorMessage={errorMessage}
            requireValue={true}
        />
    );
}
